import {specialtyTypes} from "../types/specialtyTypes";

const initState = {
    specialties: [],
    featured_specialties: [],
    specialtyListIsLoading: true,
    specialtyDetailsIsLoading: true,
    current: null,
    currentSpecialtyNotFound: false,
};

const specialtyReducer = (state = initState, action) => {
    switch (action.type) {
        case specialtyTypes.GET_All_SPECIALITIES_LIST :
            state = {
                ...state,
                specialties: action.payload,
                specialtyListIsLoading: false
            };
            break;

        case specialtyTypes.GET_SPECIALITIES_LIST :
            state = {
                ...state,
                featured_specialties: action.payload,
                specialtyListIsLoading: false
            }
            break;


        case specialtyTypes.GET_SPECIALTY_DETAILS :
            state = {
                ...state,
                current: action.payload,
                specialtyDetailsIsLoading: false
            }
            break;

        case specialtyTypes.CLEAR_SPECIALTY_LIST :
            state = {
                ...state,
                specialties: action.payload,
                specialtyListIsLoading: true,
            };
            break;

        case specialtyTypes.CURRENT_SPECIALTY_NOT_FOUND:
            state = {
                ...state,
                currentSpecialtyNotFound: action.payload,
            };
            break;

        case specialtyTypes.CLEAR_SPECIALTY_DETAILS :
            state = {
                ...state,
                current: action.payload,
                specialtyDetailsIsLoading: true,
            };
            break;
        default:
    }

    return state;
};




export default specialtyReducer